import { ValidateEmail } from "@/api/forms";
import { api } from "@/forms/api";
import { backendErrors } from "./common";

export const DEMO_FORM_STEPS = {
  FIRST_STEP: "FIRST_STEP",
  THANK_YOU_STEP: "THANK_YOU_STEP",
  MT4_SECOND_STEP: "MT4_SECOND_STEP",
  ACCESS_STEP: "ACCESS_STEP"
};

export const verifyPhone = async (email: string, phoneNumber = "") => {
  const { data: validatePhone } = await api.forms.verifyPhone({
    email,
    phone_number: phoneNumber
  });

  if (!validatePhone.success) {
    throw { errors: backendErrors(validatePhone.errors) };
  }

  if (!validatePhone.is_valid) {
    throw { errors: { phone_number: "noMatch" } };
  }

  if (validatePhone.is_exists) {
    throw { errors: { phone_number: "alreadyExists" } };
  }
};

export const mt5FirstStep = async (data: ValidateEmail) => {
  const { data: validateDate } = await api.forms.validateEmail(data);

  if (validateDate.errors) {
    throw { errors: backendErrors(validateDate.errors) };
  }

  if (!validateDate.success) {
    // new account
    await verifyPhone(data.email, data.phone_number);
    const { data: signupDate } = await api.forms.signupDemo(data);
    const { data: thankYouData } = await api.forms.mt5Download();

    return {
      next: DEMO_FORM_STEPS.THANK_YOU_STEP,
      data: { ...thankYouData, ...signupDate, newAccount: true }
    };
  }

  throw { code: "email_exists" };
};

export const mt4FirstStep = async (data: ValidateEmail) => {
  const { data: validateDate } = await api.forms.validateEmail(data);

  if (validateDate.errors) {
    throw { errors: backendErrors(validateDate.errors) };
  }

  if (!validateDate.success) {
    // new account
    await verifyPhone(data.email, data.phone_number);
    const { data: signupDate } = await api.forms.signupDemo({
      ...data,
      tradeType: "trade.mt4"
    });
    const { data: thankYouData } = await api.forms.mt4Download();

    return {
      next: DEMO_FORM_STEPS.THANK_YOU_STEP,
      data: { ...thankYouData, ...signupDate, newAccount: true }
    };
  }

  throw { code: "email_exists" };
};

export const forexFirstStep = async (data: ValidateEmail) => {
  try {
    const { data: signupDate } = await api.forms.signupDemo(data);
    const { data: thankYouData } = await api.forms.demoTyPage({
      account_id: signupDate.account_id,
      platform: signupDate.platform,
      user_id: signupDate.profile_id
    });
    return {
      next: DEMO_FORM_STEPS.THANK_YOU_STEP,
      data: { ...thankYouData, ...signupDate }
    };
  } catch ({ response }) {
    const { data } = response;

    const error_response = {
      ...data,
      errors: backendErrors(data.errors || data.fields_codes || {})
    };

    if (error_response.errors.email === "email_used") {
      throw { code: "email_exists" };
    }

    throw error_response;
  }
};

export const demoMt4SignUp = async (data: any) => {
  const { data: signupData } = await api.forms.mt4SignUp(data);

  if (signupData.errors) {
    throw { errors: backendErrors(signupData.errors) };
  }

  const { data: thankYouData } = await api.forms.mt4Download();

  return {
    next: DEMO_FORM_STEPS.THANK_YOU_STEP,
    data: { ...thankYouData, ...signupData }
  };
};
